export const formatUserId = (
    userId?: number | string | null,
    createdAt?: string | null,
) => {
    if (userId === null || userId === undefined || userId === "") {
        return "-";
    }

    const createdYear = createdAt ? new Date(createdAt).getFullYear() : NaN;
    const year = Number.isFinite(createdYear)
        ? String(createdYear).slice(-2)
        : String(new Date().getFullYear()).slice(-2);

    return `D2-${year}-${String(userId)}`;
};
